import { IPregunta, Pregunta } from "./pregunta.model";

export interface IRango {
  idRango: string;
  idPregunta: string;
  valorMinimo: number;
  valorMaximo: number;
  fechaCreacion: string;
  usuarioCreacion: string;
  fechaActualizacion: string;
  usuarioActualizacion: string;
  preguntas?: IPregunta[];
}

export class Rango {

  idRango: string;
  idPregunta: string;
  valorMinimo: number;
  valorMaximo: number;
  fechaCreacion: string;
  usuarioCreacion: string;
  fechaActualizacion: string;
  usuarioActualizacion: string;
  preguntas: Pregunta[];

  constructor(model: IRango) {
    this.idRango = model.idRango;
    this.idPregunta = model.idPregunta;
    this.valorMinimo = model.valorMinimo;
    this.valorMaximo = model.valorMaximo;
    this.fechaCreacion = model.fechaCreacion;
    this.usuarioCreacion = model.usuarioCreacion;
    this.fechaActualizacion = model.fechaActualizacion;
    this.usuarioActualizacion = model.usuarioActualizacion;
    this.preguntas = model.preguntas 
      ? model.preguntas.map(
          p => new Pregunta(p)
        ) 
      : [];
  }

}
